import React from 'react';
import {
	Spreadsheet,
	SpreadsheetBody,
	SpreadsheetHead,
	SpreadsheetHeadRow,
} from '../../../../../../DesktopScripts/reactSrc/modules/list/components/Spreadsheet';

// also for mobile view
import { SpreadsheetPreloadingAvatar } from '../../../../../../DesktopScripts/reactSrc/modules/list/components/Spreadsheet/SpreadsheetPreloadingAvatar';

import { SpreadsheetBodyRowCheckboxLayout } from '../../../../../../DesktopScripts/reactSrc/modules/list/components/Spreadsheet/SpreadsheetBodyRowCheckboxLayout';
import { SpreadsheetHeadRowCheckboxLayout } from '../../../../../../DesktopScripts/reactSrc/modules/list/components/Spreadsheet/SpreadsheetHeadRowCheckboxLayout';
import { SpreadsheetCardBodyRow } from '../../../../../../DesktopScripts/reactSrc/modules/list/components/SpreadsheetCard/SpreadsheetCardBodyRow';
import { SpreadsheetCardBodyRowCheckboxSection } from '../../../../../../DesktopScripts/reactSrc/modules/list/components/SpreadsheetCard/SpreadsheetCardBodyRowCheckboxSection';
import { SpreadsheetCardBodyRowContentCard } from '../../../../../../DesktopScripts/reactSrc/modules/list/components/SpreadsheetCard/SpreadsheetCardBodyRowContentCard';
import { SpreadsheetCardBodyRowContentSection } from '../../../../../../DesktopScripts/reactSrc/modules/list/components/SpreadsheetCard/SpreadsheetCardBodyRowContentSection';
import FlexGrid from '../../../../../components/FlexGrid';
import { EllipsisH } from '../../../../../components/Icons/EllipsisH';
import { MovingGradient } from '../../../../../components/MovingGradient';
import TooltipBtn from '../../../../../components/TooltipBtn';
import { ThemeStyle } from '../../../../../utils/const';
import { getRandomBoundary } from '../../../../list/listPage/ListLoadingPlaceholder/utils';

const listItems = Array.from(Array(5).keys());

export const CommentsListItemsPlaceholder: React.FC = () => {
	return (
		<Spreadsheet>
			<SpreadsheetHead>
				<SpreadsheetHeadRow>
					<SpreadsheetHeadRowCheckboxLayout disabled />
				</SpreadsheetHeadRow>
			</SpreadsheetHead>
			<SpreadsheetBody>
				{listItems?.map((listItem, itemId) => {
					return (
						<SpreadsheetCardBodyRow key={itemId}>
							<SpreadsheetCardBodyRowCheckboxSection>
								<SpreadsheetBodyRowCheckboxLayout disabled />
							</SpreadsheetCardBodyRowCheckboxSection>
							<SpreadsheetCardBodyRowContentSection>
								<SpreadsheetCardBodyRowContentCard>
									<div
										style={{
											display: 'grid',
											gap: '8px',
											gridTemplateColumns: 'auto 1fr auto',
										}}
									>
										<SpreadsheetPreloadingAvatar />
										<div
											style={{
												display: 'grid',
												flexDirection: 'column',
												gap: '8px',
											}}
										>
											<FlexGrid gap='tiny'>
												<MovingGradient
													height={'18px'}
													width={'16px'}
												/>
												<MovingGradient
													height={'18px'}
													width={getRandomBoundary(80, 110, 'px')}
												/>
											</FlexGrid>
											<FlexGrid gap='tiny'>
												<MovingGradient
													height={'16px'}
													width={getRandomBoundary(80, 150, 'px')}
												/>
											</FlexGrid>
										</div>
										<TooltipBtn
											tooltip={<div></div>}
											tooltipTheme={ThemeStyle.Light}
											tooltipPosition='bottom'
											tooltipAlign='end'
											icon={<EllipsisH />}
											autoClose
											styledButton
											disabled
											link
											hasTooltipIcon={false}
											size='tiny'
										/>
									</div>

									<FlexGrid
										gap='tiny'
										style={{
											marginTop: '2px',
										}}
									>
										<MovingGradient
											height={'16px'}
											width={getRandomBoundary(80, 150, 'px')}
										/>
									</FlexGrid>
									<FlexGrid gap='tiny'>
										<MovingGradient
											height={'16px'}
											width={getRandomBoundary(80, 250, 'px')}
										/>
									</FlexGrid>
								</SpreadsheetCardBodyRowContentCard>
							</SpreadsheetCardBodyRowContentSection>
						</SpreadsheetCardBodyRow>
					);
				})}
			</SpreadsheetBody>
		</Spreadsheet>
	);
};
